// extracted by mini-css-extract-plugin
module.exports = {"cta":"_1Qt1P2GG","disabled":"_3PN1IjgK","primary":"N_zDh9vx","transparent":"_1lgY3izN","secondary":"_2Lq3qrvA","fullWidth":"_1Saz4bHm","small":"GRkVcqzG","spinner":"_1mllsNWz"};